'use client';

import React from 'react';
import { Box, Typography } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

interface ShareButtonProps {
    title: string;
    subtitle: string;
}

export default function ShareButton({ title, subtitle }: ShareButtonProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                '&:hover': {
                    opacity: 0.8
                }
            }}
            onClick={() => {
                if (navigator.share) {
                    navigator.share({
                        title: title,
                        text: subtitle,
                        url: window.location.href
                    })
                }
            }}
        >
            <ShareIcon sx={{ color: 'white' }} />
            <Typography sx={{ color: 'white', ml: 1 }}>SHARE</Typography>
        </Box>
    );
}
